var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindsurfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.8403 12.2557H58.2743C55.2957 12.2509 52.8785 14.746 52.8785 17.8266V30.2855C52.8785 32.7734 50.8905 34.7888 48.5243 34.7888C47.1186 34.7888 45.7151 34.057 44.8824 32.8286L32.5807 14.6549C31.5601 13.1458 29.8992 12.2461 28.1013 12.2461C25.2968 12.2461 22.7729 14.7124 22.7729 17.757V30.2879C22.7729 32.7759 20.8011 34.7911 18.4188 34.7911C17.0084 34.7911 15.6072 34.0594 14.7744 32.831L1.00908 12.4932C0.698226 12.0325 0 12.2605 0 12.8219V23.6877C0 24.2372 0.162401 24.7698 0.466246 25.2208L14.0135 45.2324C14.8139 46.4151 15.9946 47.2933 17.3563 47.6124C20.764 48.4137 23.9003 45.7002 23.9003 42.243V29.7193C23.9003 27.2313 25.8489 25.216 28.2544 25.216H28.2614C29.7113 25.216 31.0706 25.9478 31.9034 27.1762L44.2073 45.3475C45.2304 46.859 46.8054 47.7563 48.6844 47.7563C51.5517 47.7563 54.0083 45.2875 54.0083 42.2454V29.7169C54.0083 27.229 55.9568 25.2136 58.3624 25.2136H58.8426C59.1441 25.2136 59.3878 24.9617 59.3878 24.6498V12.8195C59.3878 12.5076 59.1441 12.2557 58.8426 12.2557H58.8403Z",
    fill: "#C1E2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindsurfIcon);
export default __webpack_public_path__ + "main-static/media/windsurf-icon.742f759744a57e54c7db0e019b6eb25d.svg";
export { ForwardRef as ReactComponent };